import React, { useState, createContext } from 'react';

const AuthContext = createContext({});

const ConfigProvider = ({ children, userData }) => {
  const [usuario, setUsuario] = useState(userData);

  const atualizarUsuario = (usuarioAtualizar) => {
    setUsuario(usuarioAtualizar);
  };

  return (
    <AuthContext.Provider value={{ usuario, atualizarUsuario }}>
      {children}
    </AuthContext.Provider>
  );
};

export { ConfigProvider };

export default AuthContext;
